export default function oversToBalls(overs, ballsPerOver) {
  if (!overs || !ballsPerOver) return 0;

  const [o, b] = overs.toFixed(1).split(".");
  return (o || 0) * ballsPerOver + (b || 0);
}
